import { isAnswerField } from './answerValidation';

// Header progress for the in-app fill: "X of Y required · N%". Y is every
// required answer field; X is those that currently pass validation (filled
// and well-formed), given `errors` from validateAnswers for the same
// definition. A whole-submission error (field "answers") counts nothing as
// done. With no required fields the form reads as 100% complete.
export const progressOf = (fields, errors) => {
  const required = (fields || []).filter(
    (field) => isAnswerField(field) && field.required === true
  );
  const total = required.length;
  const list = errors || [];
  const failing = new Set(list.map((error) => error.field));
  const done = failing.has('answers')
    ? 0
    : required.filter((field) => !failing.has(field.id)).length;
  const pct = total ? Math.round((done / total) * 100) : 100;
  return { done, total, pct };
};

export const progressLabel = ({ done, total }) =>
  `${done} of ${total} required`;
